export default "__VITE_ASSET__iuT1YSMf__"